import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useTranslation } from "react-i18next";
import gridIcon from "resources/img/category/grid.png";
import listIcon from "resources/img/category/list.png";
import style from "./MobileFilterTopBar.module.css";
import CustomSelect from "./CustomSelect";
import { useDispatch } from "react-redux";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";

function MobileFilterTopBar({ filterArray, medusaProducts, list, categoryId, setCurrentType, filter, filterClick }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const GALLERY = 0;
    const LIST = 1;
    const onGalleryClick = () => {
        
        dispatch(HistoryReducer.actions.setCurrentType(GALLERY));
        setCurrentType(GALLERY);
      }
    
      const onListClick = () => {
        
        dispatch(HistoryReducer.actions.setCurrentType(LIST));
        setCurrentType(LIST);
      }
    return (
        <div style={{ position: "fixed", top: "110px", zIndex: 999, maxWidth: "1300px", backgroundColor: "white" }}>
            <VerticalFlex>

                {/* <FlexChild alignItems={"flex-start"}>
                    <Inline padding={"10px"}>
                        <P size={24} weight={700}>{t("전체")} </P>
                        <P color={"var(--main-color)"} size={24} weight={700}>{medusaProducts && categoryId === "all" ? medusaProducts.length : list ? list.length : 0}{t("개")}</P>
                        <P size={24} weight={700}> {t("브랜드")}</P>
                    </Inline>
                </FlexChild> */}
                <FlexChild>
                    <div style={{ width: "100%", height: "4px", backgroundColor: "rgba(206, 206, 206, 1)" }} />
                </FlexChild>
                <FlexChild>
                    <HorizontalFlex>
                        <FlexChild>
                            <CustomSelect
                                options={filterArray}
                                onSelect={filterClick}
                                selectedIndex={filter}
                            />
                        </FlexChild>
                        <FlexChild justifyContent={"flex-end"} padding={"0 20px 0 0"} width={"max-content"}>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "25px", alignItems: "center" }}>
                                <div style={{ width: "1.5px", height: "40px", backgroundColor: "rgba(206, 206, 206, 1)" }} />
                                <img
                                    src={gridIcon}
                                    width={"20px"}
                                    height={"20px"}
                                    style={{ cursor: "pointer" }}
                                    onClick={onGalleryClick}
                                />
                                <img
                                    src={listIcon}
                                    width={"20px"}
                                    height={"20px"}
                                    style={{ cursor: "pointer" }}
                                    onClick={onListClick}
                                />
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <div style={{ width: "100%", height: "1px", backgroundColor: "rgba(206, 206, 206, 1)" }} />
                </FlexChild>
            </VerticalFlex>
        </div>
    )
}

export default MobileFilterTopBar;